module.exports = __webpack_public_path__ + "img/57.8.TSS.c1749520.png";